import { render } from "./HeroHome.vue?vue&type=template&id=efc4edbc&scoped=true"
import script from "./HeroHome.vue?vue&type=script&lang=js"
export * from "./HeroHome.vue?vue&type=script&lang=js"

import "./HeroHome.vue?vue&type=style&index=0&id=efc4edbc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efc4edbc"]])

export default __exports__